import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import RFixasRow from './RFixasRow';

class RFixas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ativo: {},
            rfixas: [],
            rfixa: {
                tipo: 'REND',
                data: moment(),
                valor: '',
                ativo_id: '',
            },
            listaTipos: [
                {id: 'REND', nome: 'Rendimento'},
                {id: 'DEP', nome: 'Depósito'},
                {id: 'RET', nome: 'Retirada'},
            ],
			ativos: [],
			primeiraCompra: false,
			redirecionar: false
        };
    }

    componentDidMount = async () => {
        try { 
            //Obtendo o id do ativo
            if(this.props.match.params.id) {
                const res = await axios.get(`${ambiente.dev.server}/ativos/${this.props.match.params.id}`);
                const rfixa = Object.assign({}, this.state.rfixa, {ativo_id: res.data.id});
                this.setState({ ativo: res.data, rfixa });

                this.atualizarRFixas();
            } else {
                const res = await axios.get(`${ambiente.dev.server}/ativos`);
                const ativos = res.data.filter(item => item.tipo === 'RFIXA');
                this.setState({ ativos, primeiraCompra: true });
                this.handleChangeRFAtt('ativo_id', ativos[0].id);
                this.handleChangeRFAtt('tipo', 'DEP');
            }
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    atualizarRFixas = async () => {
        const resProv = await axios.get(`${ambiente.dev.server}/rfixas?ativo=${this.props.match.params.id}`);
        this.setState({ rfixas: resProv.data });
    }

    handleChangeRFAtt(nome, valor) {
        const rfixa = Object.assign({}, this.state.rfixa);
        rfixa[nome] = valor;
        this.setState({ rfixa });
    }

    handleSave = async () => {
        try {
            await axios.post(`${ambiente.dev.server}/rfixas`, this.state.rfixa);
            this.props.exibirMensagem('yay', `Renda Fixa salva com sucesso!`);
            this.atualizarRFixas();
            if (this.state.primeiraCompra) this.setState({ redirecionar: true });
          } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
          }
    }

    handleDelete = async (id) => {
        try { 
            await axios.delete(`${ambiente.dev.server}/rfixas/${id}`);
            this.props.exibirMensagem('yay', `Renda Fixa exlcluída com sucesso!`);
            this.atualizarRFixas();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        if (this.state.redirecionar) return <Redirect to="/carteira" />;
        const rfixa = this.state.rfixa;
        return (
            <div>
                <div className="row">
                    <div className="form-group col-6 col-md-4">
                        {this.state.primeiraCompra ? (
							<select autoFocus
								className="form-control"
								value={rfixa.ativo_id}
								onChange={evt => this.handleChangeRFAtt('ativo_id', evt.target.value)}>
								{this.state.ativos.map(item => (
									<option key={item.id} value={item.id}>
										{item.nome}
									</option>
								))}
							</select>
						) : (
							<h3>{this.state.ativo.nome}</h3>
						)}
                    </div>
                    <div className="form-group col-6 col-md-4" data-toggle="buttons">
                        <select className="form-control" value={rfixa.tipo} disabled={this.state.primeiraCompra}
                                onChange={evt => this.handleChangeRFAtt('tipo', evt.target.value)}>
                            {this.state.listaTipos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col col-md-4">
                        <input type="date" className="form-control" value={rfixa.data.format('YYYY-MM-DD')} 
                            onChange={evt => this.handleChangeRFAtt('data', moment(evt.target.value, 'YYYY-MM-DD'))}/>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <input type="text" className="form-control" value={rfixa.valor} placeholder="Valor"
                            onChange={evt => this.handleChangeRFAtt('valor', evt.target.value)} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
                <div className="list-group">
                    {!this.state.primeiraCompra &&
                        this.state.rfixas &&
                        this.state.rfixas.map(item => <RFixasRow key={item.id} {...item} handleDelete={this.handleDelete} /> )}
                </div>
            </div>
        );
    }
}

RFixas.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(RFixas);
  


// WEBPACK FOOTER //
// ./src/components/rfixas/RFixas.js